export type GalleryItem = {
  src: string
  alt: string
  caption: string
  location: string
}

export const gallery: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/97bdf35e-f33d-44f6-971b-b43e358e9256.jpg',
    alt: 'Remodeled kitchen with white shaker cabinets and a quartz waterfall island',
    caption: 'Full kitchen remodel',
    location: 'Greenwood Village'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9fa6e3ef-f384-4c89-aea8-04c1530fda4b.jpg',
    alt: 'Renovated bathroom with tiled shower, floating vanity, and freestanding tub',
    caption: 'Primary bath + tub refinish',
    location: 'Centennial'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ac885f77-b4ef-47b8-a8fb-ab14584e362b.jpg',
    alt: 'New composite deck with pergola and outdoor kitchen at dusk',
    caption: 'Deck, pergola & outdoor kitchen',
    location: 'Castle Rock'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2eb3d179-ee3c-4a97-9130-ce7a0baebcb4.jpg',
    alt: 'Finished basement with recessed lighting, built-in shelving, and a wet bar',
    caption: 'Basement finish',
    location: 'Parker'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ed7bc148-e562-4296-b7b6-d5dfc6840b99.jpg',
    alt: 'Luxury vinyl plank flooring being installed in a bright living room',
    caption: 'LVP flooring install',
    location: 'Lakewood'
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8fb733fe-28f6-4f67-92ad-b994e848deaf.jpg',
    alt: 'New architectural shingle roof on a suburban Colorado home',
    caption: 'Full roof replacement',
    location: 'Highlands Ranch'
  }
]
